import { useState } from 'react';
import {
  PasswordRequirements,
  usePasswordRequirements,
} from 'src/SharedCustomHooks/UsePasswordRequirements/usePasswordRequirements';

export interface UseNewPasswordFormStateReturn {
  password: string;
  confirmPassword: string;
  requirements: PasswordRequirements;
  isPasswordValid: boolean;
  passwordsMismatch: boolean;
  canSubmit: boolean;
  updatePassword: (value: string) => void;
  updateConfirmPassword: (value: string) => void;
  reset: () => void;
}

export const useNewPasswordFormState = (): UseNewPasswordFormStateReturn => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const { requirements, isValid: isPasswordValid } =
    usePasswordRequirements(password);

  const passwordsMismatch: boolean =
    confirmPassword.length > 0 && password !== confirmPassword;

  const canSubmit: boolean =
    password.length > 0 &&
    confirmPassword.length > 0 &&
    isPasswordValid &&
    !passwordsMismatch;

  const updatePassword = (value: string): void => {
    setPassword(value);
  };

  const updateConfirmPassword = (value: string): void => {
    setConfirmPassword(value);
  };

  const reset = (): void => {
    setPassword('');
    setConfirmPassword('');
  };

  return {
    password,
    confirmPassword,
    requirements,
    isPasswordValid,
    passwordsMismatch,
    canSubmit,
    updatePassword,
    updateConfirmPassword,
    reset,
  };
};
